import React from 'react';
import { Deal } from '@services/deals/types/deal';
import { DealColumn } from './deal-list-column';
import Typography from '@webapp/components/basics/typography';
import DealGrid from './deal-grid';
import styled, { useTheme } from 'styled-components';
import MotionOpacity from '../../../../components/motion/motion-opacity';

interface DealListProps {
  deals: Deal[];
  columns: DealColumn[];
  isMobile: boolean;
  childRender?: (deal: Deal) => React.ReactNode;
}

export const DealList: React.FC<DealListProps> = ({
  columns,
  deals,
  isMobile,
  childRender,
}) => {

  const theme = useTheme();

  const [showChild, setShowChild] = React.useState<string>();

  return (
    <div>
      {!isMobile && (
        <DealGrid columns={columns} isMobile={isMobile}>
          {columns.map((item) => (
            <div className={`col-${item.key}`} key={item.key}>
              <Typography key={item.key} weight="700" color={theme.colors.tertiary}>{item.label}</Typography>
            </div>
          ))}
        </DealGrid>
      )}
      {deals.map((deal) => (
        <section key={deal.id}>
          <DealEntry columns={columns} isMobile={isMobile} onClick={() => setShowChild(showChild === deal.id ? undefined : deal.id)}>
            {columns.map((item) => (
              <div className={`col-${item.key}`}>
                <Typography key={item.key} weight="700">{item.render(deal, deal.ownerId)}</Typography>
              </div>
            ))}
          </DealEntry>
          {childRender && showChild === deal.id ? (
            <MotionOpacity>
              {childRender(deal)}
            </MotionOpacity>
          ) : null}
        </section>
        
      ))}
    </div>
  );
};

const DealEntry = styled(DealGrid)`
padding: 1rem 0;
border-bottom: 1px solid ${({theme}) => theme.colors.midGray};

:last-child {
  border: 0
}
`